import { Theme, Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import Input from "../components/Input";
import Keypad from "../components/Keypad";
import NextButton from "../components/NextButton";
import ResetButton from "../components/ResetButton";
import Row from "../components/Row";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import { NavigateToNext, navigateToNext } from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";

const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const EmailContainer = styled(Container)``;
const EmailInput = styled(Input)`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  font-family: monospace;
  font-size: 1.5rem;
  height: 4rem;
  justify-content: center;
  padding-left: 1rem;
  pointer-events: auto;
  text-align: left;
  width: 24rem;
  /* pointer-events: none; */
`;

interface IEmailDispatchProps {
  onNavigateToNext: NavigateToNext;
}
interface IEmailStateProps {
  languageStrings: IStrings;
  theme: Theme.Props;
  user: Users.User;
}
type EmailProps = RouteComponentProps & IEmailDispatchProps & IEmailStateProps;
interface IEmailState {
  email: string;
  emailInput: null | HTMLElement;
  emailIsValid: boolean;
  sending: boolean;
}
type EmailState = IEmailState;

class Email extends React.Component<EmailProps, EmailState> {
  public state = {
    email: "",
    emailInput: null,
    emailIsValid: false,
    sending: false,
  };

  public handleKeypadButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { email } = this.state;
    const { value } = event.currentTarget;

    const newEmail = this.keypadValidator(email, value);

    this.setState({ email: newEmail });
  };

  public render() {
    const {
      languageStrings: strings,
      theme: { colors },
      site: { kioskUiBackgroundColor, kioskUiTitleTextColor, kioskUiButtonSuccessColor, kioskUiButtonErrorColor },
      site,
      user,
    } = this.props;
    const { email, emailIsValid, sending } = this.state;

    return (
      <ErrorBoundary>
        <EmailContainer style={{ background: kioskUiBackgroundColor }}>
          <Row align="center" justify="center">
            <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary}>
              {strings.emailHeader}
            </Title>
          </Row>
          <Column align="center" justify="space-around">
            <Row>
              <EmailInput
                id="name-input--firstname"
                name="firstname"
                onChange={this.handleInput}
                placeholder={user.email || ""}
                type="text"
                valid={emailIsValid}
                value={email}
              />
            </Row>
            <Keypad
              colors={colors}
              disabled={sending}
              isUppercase={false}
              onHandleKeypadClick={this.handleKeypadButton}
              type="email"
              site={site}
            />
          </Column>
          <Row align="center" justify="center">
            <ResetButton site={site} />
            <NextButton
              bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
              disabled={!emailIsValid}
              name="email"
              value={email}
            />
            <NextButton
              bg={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error}
              disabled={false}
              label="No Thanks"
              name={null}
              value={null}
            />
          </Row>
        </EmailContainer>
      </ErrorBoundary>
    );
  }

  private handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    let isValid = false;

    const { value } = event.currentTarget;

    this.setState({ email: value });

    if (value.match(emailRegex)) {
      isValid = true;
    }

    this.setState({ emailIsValid: isValid });
  };

  private keypadValidator = (email: string, value: string) => {
    let isValid = false;
    let newEmail = "";

    if (value === "clear") {
      isValid = false;
      newEmail = "";
    } else if (value === "backspace") {
      newEmail = email.slice(0, -1);
    } else {
      newEmail = email.concat(value);
    }

    if (newEmail.match(emailRegex)) {
      isValid = true;
    }

    this.setState({ emailIsValid: isValid });

    return newEmail;
  };
}

const mapStateToProps = ({ router: { languageStrings }, theme, user }: IState) => ({
  languageStrings,
  theme,
  user,
});

const mapDispatchToProps = {
  onNavigateToNext: navigateToNext,
};

export default connect<IEmailStateProps, IEmailDispatchProps>(mapStateToProps, mapDispatchToProps)(Email);



// WEBPACK FOOTER //
// ./src/views/Email.tsx